import { useState } from "react"
import { useLocation } from "wouter"
import {
  DeleteIcon,
  EditIcon,
  IconButton,
} from "../../../components/button/IconButton"
import { Sidepanel } from "../../../components/sidepanel/Sidepanel"
import { Project } from "../../../../types"
import { Input } from "../../../components/form/input"
import { Button } from "../../../components/button/Button"
import { toast } from "react-toastify"
import { updateProject, deleteProject } from "../../../fetch/projects"

export const EditProject = ({
  project,
  onSave,
}: {
  project: Project
  onSave?: () => void
}) => {
  const [_location, setLocation] = useLocation()
  const [open, setOpen] = useState(false)
  const [name, setName] = useState(project.name)
  const [code, setCode] = useState(project.code)
  const [errors, setErrors] = useState<Record<string, boolean>>({})

  const canArchive = project.status !== 6
  const canUnarchive = project.status === 6

  const handleArchive = async () => {
    const y = window.confirm("Vai tiešām vēlieties arhivēt šo projektu?")

    if (y) {
      try {
        const re = await updateProject(project.id, { status: 6 })
        if (!re.ok) {
          throw new Error("")
        }

        // const json = await re.json()
        // if (json.error) {
        //   throw new Error("")
        // }
        toast("Projekts veiksmīgi arhivēts!", { type: "success" })
        onSave?.()
      } catch (err) {
        toast("Neizdevās arhivēt uzdevumu, lūdzu mēģini vēlreiz!", {
          type: "error",
        })
      }
    }
  }
  const handleUnarchive = async () => {
    const y = window.confirm("Vai tiešām vēlieties atjaunot šo projektu?")

    if (y) {
      try {
        const re = await updateProject(project.id, { status: 2 })
        if (!re.ok) {
          throw new Error("")
        }
        toast("Projekts veiksmīgi atjaunots!", { type: "success" })
        onSave?.()
      } catch (err) {
        toast("Neizdevās atjaunot uzdevumu, lūdzu mēģini vēlreiz!", {
          type: "error",
        })
      }
    }
  }
  const handleDelete = async () => {
    const y = window.confirm(
      "Uzmanību! Vai tiešām vēlieties izdzēst šo projektu?"
    )

    if (y) {
      try {
        const re = await deleteProject(project.id)
        if (!re.ok) {
          throw new Error("")
        }

        // const json = await re.json()
        // if (json.error) {
        //   throw new Error("")
        // }
        toast("Projekts veiksmīgi izdzēsts!", { type: "success" })
        setLocation("/../", { replace: true })
      } catch (err) {
        toast("Neizdevās izdzēst uzdevumu, lūdzu mēģini vēlreiz!", {
          type: "error",
        })
      }
    }
  }
  const handleSave = async () => {
    const nextErr: Record<string, boolean> = {}
    if (!name) {
      nextErr.name = true
    }

    if (!code) {
      nextErr.code = true
    }
    if (Object.keys(nextErr).length) {
      setErrors(nextErr)
      toast("Nosaukums un kods ir obligāti lauki", { type: "error" })
      return
    }

    try {
      const re = await updateProject(project.id, { name, code })
      if (!re.ok) {
        throw new Error()
      }
      // const json = await re.json()
      // if (json.error) {
      //   throw new Error()
      // }
      toast("Projekts atjaunots!", { type: "success" })
      onSave?.()
    } catch (err) {
      toast("Neizdevās saglabāt, lūdzu mēģini vēlreiz", { type: "error" })
    }
  }

  return (
    <>
      <IconButton onClick={() => setOpen((curr) => !curr)}>
        {EditIcon}
      </IconButton>
      <Sidepanel
        onClose={() => setOpen(false)}
        open={open}
        footer={
          <IconButton onClick={handleDelete} className="btn-icon text error">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z"
                fill="#ff4e27"
              />
            </svg>
            Izdzēst
          </IconButton>
        }
      >
        <div>
          <Input
            label="Projekts"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={errors.name}
          />
          <Input
            label="Kods"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            error={errors.code}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            {canArchive && (
              <IconButton onClick={handleArchive} className="btn-icon text">
                {DeleteIcon} Arhivēt
              </IconButton>
            )}
            {canUnarchive && (
              <IconButton onClick={handleUnarchive} className="btn-icon text">
                {EditIcon} Atjaunot
              </IconButton>
            )}
            <div style={{ display: "flex", gap: 8 }}>
              <Button variant="secondary" onClick={() => setOpen(false)}>
                Atcelt
              </Button>
              <Button onClick={handleSave}>Saglabāt</Button>
            </div>
          </div>
        </div>
      </Sidepanel>
    </>
  )
}
